export default __webpack_public_path__ + "static/media/Mark-4-HUD-00.6bebc24b.jpg";